import * as React from 'react';
import { CircularProgress } from "@material-ui/core";
import i18next from 'i18next';
import LabelHint from "../../_components/LabelHint";
import TicketTypeItem from './TicketTypeItem';

export default function TicketTypeList(props) {
  const addTicket = () => {
    ticketTypes.push({ id: 0, name: "", cost: "", name_i18n: {}, exponent: false, invoice_payment: false, required_anketa: [], optional_anketa: [] });
    stateSetter('tickets_tmp', ticketTypes);
  };

  let { ticketTypes } = props;
  const { loadingTickets, conferenceId, stateSetter } = props;

  return (<div className="form__group">
    <div class="form__group-body">
      {loadingTickets && (
        <div className="shadow">
          <div className="shadow_circle">
            <CircularProgress />
          </div>
        </div>
      )}

      {!loadingTickets && (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <LabelHint
            title="ticket_types"
            hint="hint_ticket_types"
          />
          <div class="form__group-top">
            <button
              type="button"
              class="form__btn"
              onClick={addTicket}
            >
              <svg width="29" height="29">
                <use href="./img/sprite.svg#add-icon"></use>
              </svg>
              <span>{i18next.t("btn_add")}</span>
            </button>
          </div>
        </div>
      )}
      {!loadingTickets &&
        ticketTypes.map(function (item, index) {
          return <TicketTypeItem {...props} index={index} item={item} />;
        })}
    </div>
  </div>);
}
